export default "__VITE_ASSET__MkCp4njM__"